export default __webpack_public_path__ + "static/media/web-icon.8a4ed309.svg";